import React, { useRef } from 'react';
import PopupBase from '../../popup/base/PopupBase';
import CustomButton from '../buttons/CustomButton';
import InsuranceDocumentAttachments from './InsuranceDocumentAttachments';
import styles from './styles.module.css';

/**
 * Popup "Anexos" de um pedido médico ou de uma guia. `onClose(changed)` diz se
 * algo foi enviado, editado ou excluído, para a lista dona atualizar o contador.
 */
function InsuranceDocumentAttachmentsPopup({ patientId, context, contextId, subject, enabled = true, onClose }) {
  const changedRef = useRef(false);

  const close = () => onClose(changedRef.current);

  const content = (
    <InsuranceDocumentAttachments
      patientId={patientId}
      context={context}
      contextId={contextId}
      subject={subject}
      enabled={enabled}
      onChanged={() => { changedRef.current = true; }}
    />
  );

  const footer = (
    <div className={styles.footer}>
      <CustomButton style="primary" variant="text" label="Fechar" onClick={close} />
    </div>
  );

  return <PopupBase Title="Anexos" Content={content} Footer={footer} OnClose={close} maxWidth="sm" />;
}

export default InsuranceDocumentAttachmentsPopup;
